import React from 'react';
import { Button, Modal } from 'antd';
import Typography from '../helpers/fonts';
import { useSmallScreen } from '../helpers/isSmallScreen';
import { useTranslation } from 'react-i18next';

export const ViewerConfirmDeleteMessage: React.FunctionComponent<{
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    onConfirm: () => void
}> = ({isOpen,setIsOpen, onConfirm}) => {
  const { t } = useTranslation();
  const isSmallScreen = useSmallScreen();

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        margin: isSmallScreen ? 0 : 20,
      }}
    >
      <div style={{ display: 'grid' }}>
                <Modal
                  centered
                  visible={isOpen}
                  title={ <Typography styleid={3}> {t(`confirmDeleteDoorsAndWindows.title`)}</Typography>}
                  footer={[
                    <Button key="back" onClick={() => setIsOpen(false)}>
                      {t(`confirmDeleteDoorsAndWindows.cancel`)}
                    </Button>,
                    <Button key="submit" type="primary" onClick={onConfirm}>
                      {t(`confirmDeleteDoorsAndWindows.yes`)}
                    </Button>]}
                  closeIcon={<></>}
                >
                  <p>
                    <Typography styleid={6}>
                    {t(`confirmDeleteDoorsAndWindows.text`)}
                    </Typography>
                  </p>
                </Modal>
              
      </div>
    </div>
  )
}
